// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2GQIv","buttons":"RemoveExpirationActionButtons_buttons__2e04X"};